export const GET_PRODUCTS = 'GET_PRODUCTS';
export const GET_PRODUCTS_ADMIN = 'GET_PRODUCTS_ADMIN';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const PRODUCT_ERROR = 'PRODUCT_ERROR';
